export default __webpack_public_path__ + "static/media/circle_close_button.9082e7ef.svg";